export enum BankCategory {
  ACHIEVEMENTS = 'achievements',
  REWARDS = 'rewards',
  TRANSFERS = 'transfer',
  WAGES = 'wages',
  SPONSORING = 'sponsoring',
  CLUB_GROUNDS = 'club_grounds',
  STADIUM = 'stadium',
  ENTRANCE_FEE = 'entrance_fee',
}
